"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3467],{

/***/ 3467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Masonry; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/LinkPreviewCard-2daafeaa.mjs
var LinkPreviewCard_2daafeaa = __webpack_require__(4382);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Masonry.js











function T(a, t) {
  if (a == null)
    return {};
  var e = A(a, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(a);
    for (r = 0; r < o.length; r++)
      n = o[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(a, n) && (e[n] = a[n]);
  }
  return e;
}
function A(a, t) {
  if (a == null)
    return {};
  var e = {}, n = Object.keys(a), r, o;
  for (o = 0; o < n.length; o++)
    r = n[o], !(t.indexOf(r) >= 0) && (e[r] = a[r]);
  return e;
}
function f() {
  return f = Object.assign || function(a) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
    }
    return a;
  }, f.apply(this, arguments);
}
function w(a, t) {
  var e = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(a);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(a, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function p(a) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w(Object(e), !0).forEach(function(n) {
      B(a, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(e)) : w(Object(e)).forEach(function(n) {
      Object.defineProperty(a, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return a;
}
function B(a, t, e) {
  return t in a ? Object.defineProperty(a, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : a[t] = e, a;
}
const G = {
  breakpointCols: void 0,
  // optional, number or object { default: number, [key: number]: number }
  className: void 0,
  // required, string
  columnClassName: void 0,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: void 0,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: void 0,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: void 0
}, b = 2;
class v extends react.Component {
  constructor(t) {
    super(t), this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this), this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this);
    let e;
    this.props.breakpointCols && this.props.breakpointCols.default ? e = this.props.breakpointCols.default : e = parseInt(this.props.breakpointCols) || b, this.state = {
      columnCount: e
    };
  }
  componentDidMount() {
    this.reCalculateColumnCount(), window && window.addEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  componentDidUpdate() {
    this.reCalculateColumnCount();
  }
  componentWillUnmount() {
    window && window.removeEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      this.reCalculateColumnCount();
      return;
    }
    window.cancelAnimationFrame && window.cancelAnimationFrame(this._lastRecalculateAnimationFrame), this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }
  reCalculateColumnCount() {
    const t = window && window.innerWidth || 1 / 0;
    let e = this.props.breakpointCols;
    typeof e != "object" && (e = {
      default: parseInt(e) || b
    });
    let n = 1 / 0, r = e.default || b;
    for (let o in e) {
      const i = parseInt(o);
      i > 0 && t <= i && i < n && (n = i, r = e[o]);
    }
    r = Math.max(1, parseInt(r) || 1), this.state.columnCount !== r && this.setState({
      columnCount: r
    });
  }
  itemsInColumns() {
    const t = this.state.columnCount, e = new Array(t), n = react.Children.toArray(this.props.children);
    for (let r = 0; r < n.length; r++) {
      const o = r % t;
      e[o] || (e[o] = []), e[o].push(n[r]);
    }
    return e;
  }
  renderColumns() {
    const {
      column: t,
      columnAttrs: e = {},
      columnClassName: n
    } = this.props, r = this.itemsInColumns(), o = `${100 / r.length}%`;
    let i = n;
    i && typeof i != "string" && (this.logDeprecated('The property "columnClassName" requires a string'), typeof i > "u" && (i = "my-masonry-grid_column"));
    const l = p(p(p({}, t), e), {}, {
      style: p(p({}, e.style), {}, {
        width: o
      }),
      className: i
    });
    return r.map((u, c) => /* @__PURE__ */ react.createElement("div", f({}, l, {
      key: c
    }), u));
  }
  logDeprecated(t) {
    console.error("[Masonry]", t);
  }
  render() {
    const t = this.props, {
      // ignored
      children: e,
      breakpointCols: n,
      columnClassName: r,
      columnAttrs: o,
      column: i,
      // used
      className: l
    } = t, u = T(t, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);
    let c = l;
    return typeof l != "string" && (this.logDeprecated('The property "className" requires a string'), typeof l > "u" && (c = "my-masonry-grid")), /* @__PURE__ */ react.createElement("div", f({}, u, {
      className: c
    }), this.renderColumns());
  }
}
v.defaultProps = G;
const M = "masonry-grid", H = "desktop", F = "masonry-grid__column", W = "masonry-grid__card-container", $ = "masonry-card__image-container", y = {
  masonryGrid: M,
  desktop: H,
  masonryGridColumn: F,
  masonryGridCardContainer: W,
  masonryCardImageContainer: $
}, U = "masonry-card", q = "masonry-card__title", R = "masonry-card__image-container", z = "masonry-card--pressed", K = "desktop", J = "masonry-card__save-button", Q = "masonry-card__save-button--hidden", V = "masonry-card__info", X = "masonry-card__date", Y = "masonry-card__date--hidden", Z = "masonry-card__title--hidden", ee = "masonry-card__description", te = "masonry-card__description--hidden", m = {
  masonryCard: U,
  masonryCardTitle: q,
  masonryCardImageContainer: R,
  masonryCardPressed: z,
  desktop: K,
  masonryCardSaveButton: J,
  masonryCardSaveButtonHidden: Q,
  masonryCardInfo: V,
  masonryCardDate: X,
  masonryCardDateHidden: Y,
  masonryCardTitleHidden: Z,
  masonryCardDescription: ee,
  masonryCardDescriptionHidden: te
}, ne = ({
  title: a,
  description: t,
  date: e,
  link: n,
  linkLocale: r,
  image: o
}) => {
  const [i, l] = (0,react.useState)(!1);
  return /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      className: (0,app_a75c1d35.c)(
        m.masonryCard,
        i && m.masonryCardPressed
      ),
      href: n,
      locale: r,
      "data-testid": "masonry-card",
      disableLinkTextStyle: !0,
      onMouseDown: () => l(!0),
      onMouseUp: () => l(!1),
      onMouseLeave: () => l(!1)
    },
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(m.masonryCardImageContainer),
        "data-testid": "masonry-image"
      },
      o && /* @__PURE__ */ react.createElement(
        Image_d6406817.I,
        {
          credits: o.credits,
          src: o.src,
          width: o.width,
          height: o.height,
          altText: o.altText,
          imageLoader: o.imageLoader,
          styling: o.styling
        }
      )
    ), /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(m.masonryCardInfo),
        "data-testid": "masonry-content"
      },
      /* @__PURE__ */ react.createElement(
        "p",
        {
          className: (0,app_a75c1d35.c)(
            m.masonryCardDate,
            app_a75c1d35.t.textsLeadText,
            e === void 0 && m.masonryCardDateHidden
          )
        },
        `Date ${e}`
      ),
      /* @__PURE__ */ react.createElement("div", { className: m.masonryCardTitle }, /* @__PURE__ */ react.createElement("p", { className: app_a75c1d35.t.textsComponentTitleBold }, a)),
      /* @__PURE__ */ react.createElement(
        "p",
        {
          className: (0,app_a75c1d35.c)(
            m.masonryCardDescription,
            app_a75c1d35.t.textsLeadText
          )
        },
        t
      )
    ))
  );
}, re = {
  default: 2,
  [app_a75c1d35.D.md - 1]: 1
};
function ye(a) {
  const { variants: t } = a;
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      "data-testid": "masonry-block",
      topPadding: Block_9b78bd10.B.Padding.NONE,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { "data-testid": "masonry-content" }, /* @__PURE__ */ react.createElement(
      v,
      {
        breakpointCols: re,
        className: (0,app_a75c1d35.c)(y.masonryGrid),
        columnClassName: (0,app_a75c1d35.c)(y.masonryGridColumn),
        "data-testid": "masonry"
      },
      t && t.length && t.map((e, n) => {
        const { masonry: r, linkPreview: o } = e;
        if (r && r.link)
          return /* @__PURE__ */ react.createElement(
            "div",
            {
              key: n,
              className: (0,app_a75c1d35.c)(y.masonryGridCardContainer)
            },
            /* @__PURE__ */ react.createElement(ne, { ...r })
          );
        if (o) {
          const { card: i, hasImages: l, hasSaveButton: u } = o, {
            cardIntroText: c,
            cardTitle: _,
            imageProps: k,
            link: g,
            linkLabel: O,
            linkLocale: D,
            linkDescription: P,
            onSave: E,
            isSaved: N
          } = i;
          return /* @__PURE__ */ react.createElement(
            "div",
            {
              className: (0,app_a75c1d35.c)(y.masonryGridCardContainer),
              key: i.link
            },
            /* @__PURE__ */ react.createElement(
              LinkPreviewCard_2daafeaa.L,
              {
                key: g,
                cardIntroText: c,
                cardTitle: _,
                imageProps: k,
                link: g,
                linkDescription: P,
                linkLocale: D,
                hasImages: l,
                hasSaveButton: u,
                linkLabel: O,
                onSave: E,
                isSaved: N
              }
            )
          );
        }
      })
    ))
  );
}

//# sourceMappingURL=Masonry.js.map

// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Masonry/Masonry.tsx









function Masonry(props) {
    var rawVariants = props.variants;
    var isPreview = (0,router.useRouter)().isPreview;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var variants = (0,magnolia/* jcrMultiFieldToArray */.FE)(rawVariants).map(function(variant) {
        if (!("page" in variant)) {
            return {
                linkPreview: mapToLinkPreviewCardProps(variant, imageDataHandler)
            };
        }
        return {
            masonry: mapToMasonryCardProps(variant, isPreview, imageDataHandler)
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ye, {
        variants: variants
    });
}
var mapToMasonryCardProps = function(variant, isPreview, imageDataHandler) {
    var ref;
    var page = variant.page;
    var title = page.title, description = page.description, introductionImage = page.introductionImage;
    var imageData = imageDataHandler(introductionImage);
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        altText: title,
        styling: Image_d6406817.a.MASONRY_CARD,
        credits: introductionImage === null || introductionImage === void 0 ? void 0 : (ref = introductionImage.metadata) === null || ref === void 0 ? void 0 : ref.rights
    });
    return {
        title: title,
        description: description,
        link: (0,magnolia/* formatPageLink */.Jd)(page["@path"], isPreview),
        image: imageProps
    };
};
var mapToLinkPreviewCardProps = function(linkPreviewVariant, imageDataHandler) {
    var ref;
    if (!linkPreviewVariant.card) {
        return undefined;
    }
    var card = mapToCardProps(linkPreviewVariant.card, imageDataHandler);
    return {
        card: card,
        hasSaveButton: false,
        hasImages: (linkPreviewVariant === null || linkPreviewVariant === void 0 ? void 0 : (ref = linkPreviewVariant.card) === null || ref === void 0 ? void 0 : ref.field) === "image"
    };
};
function mapToCardProps(node, imageDataHandler) {
    var ref;
    var image = node.image, cardTitle = node.cardTitle, cardIntroText = node.cardIntroText, link = node.link, altText = node.altText, linkLabel = node.linkLabel, linkDescription = node.linkDescription;
    if (!image || !altText) {
        return {
            cardTitle: cardTitle,
            cardIntroText: cardIntroText,
            link: link,
            linkLabel: linkLabel,
            linkDescription: linkDescription
        };
    }
    var imageData = imageDataHandler(image, {
        maxViewport: app/* Viewport.sm */.l_.sm
    });
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        altText: altText,
        credits: image === null || image === void 0 ? void 0 : (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.rights
    });
    return {
        cardTitle: cardTitle,
        cardIntroText: cardIntroText,
        link: link,
        linkLabel: linkLabel,
        linkDescription: linkDescription,
        imageProps: imageProps
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/Masonry/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 4382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Y; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5905);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1416);





const N = "link-preview-card", L = "desktop", T = "image-container", S = "image", B = "badge", x = "link-wrapper", E = "preview-container", W = "preview-content", P = "card-title", f = "card-intro-text", y = "preview-link", H = "cta-hover", A = "save-button-container", M = "cta", O = "no-images-card", _ = "no-images-preview-content", R = "no-images-card-link-wrapper", D = "no-save-no-images-button-card-height", V = "no-save-button-card-link-wrapper", j = "no-save-no-images-link-wrapper", q = "no-save-button-preview-content", z = "no-save-button-cta", F = "hide-cta-on-mobile", e = {
  linkPreviewCard: N,
  desktop: L,
  imageContainer: T,
  image: S,
  badge: B,
  linkWrapper: x,
  previewContainer: E,
  previewContent: W,
  cardTitle: P,
  cardIntroText: f,
  previewLink: y,
  ctaHover: H,
  saveButtonContainer: A,
  cta: M,
  noImagesCard: O,
  noImagesPreviewContent: _,
  noImagesCardLinkWrapper: R,
  noSaveNoImagesButtonCardHeight: D,
  noSaveButtonCardLinkWrapper: V,
  noSaveNoImagesLinkWrapper: j,
  noSaveButtonPreviewContent: q,
  noSaveButtonCta: z,
  hideCtaOnMobile: F
};
function Y(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: p,
    imageProps: a,
    hasImages: n,
    hasSaveButton: r,
    showCTAOnMobile: v = !0,
    newTab: c = !0,
    badge: C
  } = l, k = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !r && !n,
    [e.hideCtaOnMobile]: !v
  }), w = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !r,
    [e.noSaveNoImagesLinkWrapper]: !n && !r
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: k, "data-testid": "link-preview-container" }, n && a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
    {
      credits: a.credits,
      src: a.src,
      width: a.width,
      height: a.height,
      altText: a.altText,
      imageLoader: a.imageLoader,
      className: e.image,
      styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.a.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: w }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      href: m,
      locale: p,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      G,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: r,
        newTab: c
      }
    ))
  )));
}
const G = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: p, newTab: a } = l, n = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), r = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
    e.cardTitle
  ), v = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText,
    e.cardIntroText
  ), c = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", { className: r }, d), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: v }, i), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__.C,
    {
      containerClassName: c,
      as: "div",
      text: p,
      showCTAIcon: a
    }
  ));
};

//# sourceMappingURL=LinkPreviewCard-2daafeaa.mjs.map


/***/ })

}]);